import React from 'react'
import { Icon } from '@iconify/react'

import styles from './ProjectHealthDashboard.module.css'

const ProjectCapacityDashboard = ({ projectName }) => {
    const displayName = projectName || 'Project'

    return (
        <div className={styles.dashboard}>
            <header className={styles.dashboardHeader}>
                <div>
                    <p className={styles.dashboardEyebrow}>Reports</p>
                    <h2 className={styles.dashboardTitle}>
                        {displayName} capacity
                    </h2>
                    <p className={styles.dashboardSubtitle}>
                        Team workload and resource allocation
                    </p>
                </div>
            </header>
            <div className={styles.comingSoonState}>
                <div className={styles.comingSoonIconBadge} aria-hidden>
                    <Icon
                        icon="mdi:chart-timeline-variant"
                        width={28}
                        height={28}
                        className={styles.comingSoonIcon}
                    />
                </div>
                <p className={styles.comingSoonTitle}>Capacity report coming soon</p>
                <p className={styles.comingSoonHint}>
                    Team workload and resource allocation insights for this
                    project will be available here.
                </p>
                <span className={styles.comingSoonBadge}>Coming soon</span>
            </div>
        </div>
    )
}

export default ProjectCapacityDashboard
